"use strict";
"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = __importDefault(require("react"));
var ColorRadioItem = react_2.default.forwardRef(function (_a, ref) {
    var color = _a.color, tooltip = _a.tooltip, props = __rest(_a, ["color", "tooltip"]);
    var _b = (0, react_1.useRadio)(props), Component = _b.Component, isSelected = _b.isSelected, isFocusVisible = _b.isFocusVisible, getBaseProps = _b.getBaseProps, getInputProps = _b.getInputProps;
    return ((0, jsx_runtime_1.jsx)(react_1.Tooltip, __assign({ content: tooltip, delay: 1000, isDisabled: !tooltip, offset: 0, placement: "top" }, { children: (0, jsx_runtime_1.jsxs)(Component, __assign({}, getBaseProps(), { ref: ref }, { children: [(0, jsx_runtime_1.jsx)(react_1.VisuallyHidden, { children: (0, jsx_runtime_1.jsx)("input", __assign({}, getInputProps())) }), (0, jsx_runtime_1.jsx)("span", { className: (0, react_1.cn)("pointer-events-none h-8 w-8 rounded-full border border-black border-opacity-10 transition-transform group-data-[pressed=true]:scale-90", {
                        "ring-2 ring-offset-2 ring-offset-content1": isSelected,
                    }), style: {
                        backgroundColor: color,
                        // @ts-ignore
                        "--tw-ring-color": isSelected || isFocusVisible ? "hsl(var(--nextui-primary))" : "transparent",
                    } })] })) })));
});
ColorRadioItem.displayName = "ColorRadioItem";
exports.default = ColorRadioItem;
